export enum AGENT_HUB {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=746474700
     */
    AGENT_DELETED = 'AGENT_HUB.AGENT_DELETED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744861578
     */
    AGENT_PUBLISHED = 'AGENT_HUB.AGENT_PUBLISHED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744861051
     */
    AGENT_SAVED_AS_DRAFT = 'AGENT_HUB.AGENT_SAVED_AS_DRAFT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=739929735
     */
    AGENT_STUDIO = 'AGENT_HUB.AGENT_STUDIO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=748322030
     */
    AUDIENCE_MANAGEMENT = 'AGENT_HUB.AUDIENCE_MANAGEMENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=746484539
     */
    CONFIRM_DELETE_AGENT = 'AGENT_HUB.CONFIRM_DELETE_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=746482616
     */
    DELETE_AGENT = 'AGENT_HUB.DELETE_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744758446
     */
    EDIT_AGENT = 'AGENT_HUB.EDIT_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744786509
     */
    EXPERTISE = 'AGENT_HUB_SEARCH.EXPERTISE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744821023
     */
    INSTRUCTIONS = 'AGENT_HUB_SEARCH.INSTRUCTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=786227136
     */
    INSTRUCTIONS_FIELD_HELPER = 'AGENT_HUB.INSTRUCTIONS_FIELD_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=742368230
     */
    NEW_AGENT = 'AGENT_HUB.NEW_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=773777011
     */
    TOOLS = 'AGENT_HUB.TOOLS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792110911
     */
    KNOWLEDGE_SOURCES = 'AGENT_HUB.KNOWLEDGE_SOURCES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578183
     */
    WHAT_DO_YOU_WANT_TO_BUILD = 'AGENT_HUB.WHAT_DO_YOU_WANT_TO_BUILD',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578190
     */
    SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI = 'AGENT_HUB.SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578492
     */
    SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI_DESCRIPTION = 'AGENT_HUB.SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578503
     */
    AI_AGENT = 'AGENT_HUB.AI_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578532
     */
    AI_AGENT_DESCRIPTION = 'AGENT_HUB.AI_AGENT_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578587
     */
    LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY = 'AGENT_HUB.LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578600
     */
    LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY_DESCRIPTION = 'AGENT_HUB.LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY_DESCRIPTION',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7556600
     */
    AUTOMATIC_OPTION = 'FRONT.SETTINGS.SELECTION_LIST',
}
